export default "__VITE_ASSET__5b5ecac0__"